import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import postUser from 'Api/user/postUser';
import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';

import { useUserState } from 'View/user/state';

import upsertUserPayload from './model/request/upsertUserPayload';

const usePostUser = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const navigate = useNavigate();
  const { updateState } = useUserState();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = upsertUserPayload(formData);

      const result = await postUser({ payload });

      return result;
    },
    onMutate: () => {
      onShowLoader({ variant: 'loader-primary' });
    },
    onSuccess: () => {
      onOpenToast({
        status: 'success',
        description: 'User created successfully',
        duration: 5,
        isClosable: true,
      });
      navigate('/master-data/user');
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.errors?.[0]?.message || 'Failed to create user';

      updateState({
        alertProps: {
          isOpen: true,
          type: 'error',
          title: 'Failed to create user',
          description: errorMessage,
          onClose: () => updateState({ alertProps: {} }),
          marginBottom: '12px',
        },
      });

      navigate('/master-data/user');
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostUser;
